import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\LinkItemOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/LinkItemOptionToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/link'
*/
const LinkItemOptionToEnaosController = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LinkItemOptionToEnaosController.url(args, options),
    method: 'post',
})

LinkItemOptionToEnaosController.definition = {
    methods: ["post"],
    url: '/api/item/{item}/enaos/{enaos_item}/link',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\LinkItemOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/LinkItemOptionToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/link'
*/
LinkItemOptionToEnaosController.url = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            enaos_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        enaos_item: typeof args.enaos_item === 'object'
        ? args.enaos_item.id
        : args.enaos_item,
    }

    return LinkItemOptionToEnaosController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{enaos_item}', parsedArgs.enaos_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\LinkItemOptionToEnaosController::__invoke
* @see app/Http/Controllers/Item/LinkItemOptionToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/link'
*/
LinkItemOptionToEnaosController.post = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LinkItemOptionToEnaosController.url(args, options),
    method: 'post',
})

export default LinkItemOptionToEnaosController